import { Styles, generateClasses } from '@lsy-netline/netline-ui';

export const errorDetailsClasses = generateClasses('ErrorDetails', [
  'root',
  'title',
  'expandButton',
  'content',
  'footer',
  'copiedIcon',
] as const);

export const errorDetailsRootClasses = generateClasses(errorDetailsClasses.root, ['expanded'] as const, true);

const styles: Styles = ({ theme: { spacing, colors, palette } }) => ({
  [`&.${errorDetailsClasses.root}`]: {
    display: 'flex',
    flexDirection: 'column',
    [`&${errorDetailsRootClasses.expanded} .${errorDetailsClasses.expandButton}`]: {
      transform: 'rotate(-180deg)',
    },
  },
  [`.${errorDetailsClasses.title}`]: {
    marginBottom: spacing(1),
    display: 'flex',
  },
  [`.${errorDetailsClasses.expandButton}`]: {
    marginLeft: spacing(0.5),
    width: 16,
    height: 16,
    borderRadius: 2,
    color: colors.grey[600],
    transition: 'transform 0.3s',
  },
  [`.${errorDetailsClasses.content}`]: {
    overflowY: 'auto',
    overflowX: 'hidden',
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
  },
  [`.${errorDetailsClasses.footer}`]: {
    paddingTop: spacing(1),
    color: palette.grey[600],
  },
  [`.${errorDetailsClasses.copiedIcon}`]: {
    verticalAlign: 'sub',
    color: palette.success.dark,
    marginRight: spacing(-0.5),
  },
});

export default styles;
